import * as types from './mutationTypes'

export default {
  [types.SHOW_TOAST] (state, payload) {
    state.loadingCounter += 1
    state.toast.message = payload;
  },
  setGiftBox(state, data) {
    state.giftBox.id = data.id;
    state.giftBox.loyaltyCardListId = data.loyaltyCardListId;
  },
  /** 儲存 SettingInfo */
  putSettingInfo (state, payload) {
    state.settingInfo = payload;
  },
  /** 更新掃描結果 */
  putScanResult (state, result) {
    state.scanResult = result;
  },
  /** 清除掃描結果 */
  clrScanResult (state) {
    state.scanResult = '';
  },
  /** 設定是否異動頁籤 */
  setChangePageData (state, data) {
    //把參數預先存到 changePageData，跳頁後再直接從 changePageData裡取出參數做判斷
    state.changePageData = {...data};
  },
  /**頁面變數快照 */
  savePageSnapshot (state, payload) {
    if (payload.variable!=='delete') {
      state.pageSnapshot[payload.routeName] = payload.variable;
    }
  },
  /**設定當前購物車store_id */
  setCartStoreId (state,input) {
    window.localStorage.setItem('cartStoreId',input);
    state.cartStoreId = input;
  },
  /**修改準備中訂單數量 */
  increasePrepareCount(state,input) {
    state.orderRecordPrepareCount += input;
    if (state.orderRecordPrepareCount<0) {
      state.orderRecordPrepareCount = 0;
    }
  },


  /** 新增搜尋關鍵字到歷史關鍵字陣列 */
  addSearchRecord (state, input) {
    state.searchRecord.lastKeyword = input;

    //判斷是否有重複，沒重複才加入陣列
    let repeat = false;
    if (state.searchRecord.keywordList.length > 0) {
      state.searchRecord.keywordList.forEach((item, index) => {
        if (input === item) {
          repeat = true;
        }
      });
    }
    if (!repeat) {
      state.searchRecord.keywordList.unshift(input) ;
    }

    if (state.searchRecord.keywordList.length > state.searchRecord.maxLength) {
      state.searchRecord.keywordList.splice(state.searchRecord.keywordList.length-1, 1);
    }
  },
  /** 新增搜尋關鍵字於歷史關鍵字陣列最後 */
  appendSearchRecord (state, input) {
    state.searchRecord.lastKeyword = input;

    //判斷是否有重複，沒重複才加入陣列
    let repeat = false;
    if (state.searchRecord.keywordList.length > 0) {
      state.searchRecord.keywordList.forEach((item, index) => {
        if (input === item) {
          repeat = true;
        }
      });
    }
    if (!repeat) {
      state.searchRecord.keywordList.push(input) ;
    }

    if (state.searchRecord.keywordList.length > state.searchRecord.maxLength) {
      state.searchRecord.keywordList.splice(state.searchRecord.keywordList.length-1, 1);
    }
  },
  /** 設定歷史關鍵字列表 */
  setKeywordList (state, list) {
    // state.searchRecord.keywordList.pop();
    // state.searchRecord.keywordList = state.searchRecord.keywordList.concat(list);
    state.searchRecord.keywordList = list;
  },
  /** 設定上次搜尋的關鍵字 */
  setLastKeyword (state, input) {
    state.searchRecord.lastKeyword = input;
  },
  /** 刪除某個歷史搜尋關鍵字 */
  removeSearchRecordByIndex (state, index) {
    state.searchRecord.keywordList.splice(index, 1);
  },
  /** 清除搜尋 */
  clrSearchRecord (state) {
    state.searchRecord.keywordList.pop() ;
  },

  /** 清除商圈購物車更新key */
  clrShopAreaCart (state) {
    state.searchRecord.updateCartKey = 0 ;
  },
  /** 更新商圈購物車 */
  updateShopAreaCart (state, input) {
    if (input < 0) {
      state.shopAreaCartData.updateCartKey++;
    } else {
      state.shopAreaCartData.updateCartKey = input;
    }
  },
  openShopAreaCartDetail (state) {
    state.shopAreaCartData.openCartDetailKey++;
  },

  /** 儲存註冊頁快照 */
  saveRegPageSnapshot (state, input) {
    state.regPageSnapshot = {
      name: input.name,
      birthday: input.birthday,
      password: input.password,
    };
  },
  clearCartPageSnapshot(state, payload = {}) {

    let paymentType = ''
    let taxIdNumber = ''
    let mobileBarcode = ''
    let userAddressParams = {}

    if(payload.isKeepValue) {
      paymentType = state.cartPageSnapshot.paymentType
      taxIdNumber = state.cartPageSnapshot.taxIdNumber
      mobileBarcode = state.cartPageSnapshot.mobileBarcode,    //手機條碼(載具)
      userAddressParams = state.cartPageSnapshot.userAddressParams
    }

    state.cartPageSnapshot={     //購物車頁面快照
      orderSettingTypeId: 0,
      isLoading: false,
      orderSn: '',
      radioTake: '1',         //取餐方式
      showBank: false,        //更改付款方式
      paymentType: paymentType,
      showModel: false,       //取消揪團時，被分享者要出現的提示
      completeModel: false,   //點餐成功彈框
      fareModel: false,       //外送費說明彈框
      payModel: false,        //付款說明彈框
      showDelDialog: false,   //刪除餐點彈框

      scrollHeight: '',
      scrollTop: '',
      storeId: 0,//店家id
      shoppingCartMealChoiceList: [], //購物車中的餐點資訊
      shoppingCartMealData: [],       //所有餐點資料
      refreshChoiceList: true,
      delMealIndex: null,     //暫存正在被刪除的餐點
      delMealOldVal:null,     //刪除前的數量
      delMealArr: [],         //紀錄被刪除的餐點
      originTotalPrice: 0,    //小計
      oldOriginTotalPrice: 0, //用優惠前小計
      sumAmount: 0,           //總餐點數量
      couponList: [],         //優惠表
      discountLimit: null,        //優惠限制設定
      concatCouponList: false,    //是否拼接優惠表
      couponChoiceList: [],       //已選擇的優惠券選項
      couponChoiceListItem: [],   //已選擇的優惠券
      calculatorCouponPrice: null,    //計算經過coupon的金額
      orderGift: [],      //可獲得票券
      taxIdNumber: taxIdNumber,    //統一編號
      mobileBarcode: mobileBarcode,    //手機條碼(載具)
      remark: '',         //訂單備註

      storeInfo:{},
      userAddressData:{},
      userAddressId:0,
      userAddressParams: userAddressParams,
      deliveryConditionList:[],//外送費資訊
      maxDistance:null,//最大運送距離
      isRequiredRemark:false,//訂單備註欄位是否必填
      isRequestTableware:false,//是否顯示需要拋棄式餐具、吸管嗎？
      isRequiredTableware:false,//是否需要拋棄式餐具、吸管
      remarkPrompt:'',//訂單備註欄位提示
      checkoutInstructions:'',//結帳說明
      isCanCoupon:false,//顯示優惠券使用欄位(開啟時，可提供顧客使用優惠券)
      isCanTaxIdNumber:false,//顯示統一編號輸入欄位(開啟時，可提供顧客輸入統編)
      isCanMobileBarcode:false,//顯示手機條碼(載具)輸入欄位(開啟時，可提供顧客輸入手機條碼)
      mealPreparationTimeType:0,//餐點平均準備時間

      orderDeliveryList:[],//取餐方式（自取、外送、小短腿）
      completeOrderData: {
        "userName":   "",
        "radioTake":  0,
        "totalPrice": 0,
        "day":        "",
        "time":       "",
        "week":       "",
      },

      isCreditCard: false,//高鉅信用卡彈框
      takeoutId:0,//我想修改訂單回來帶入參數
      paymentMethod:{},
      orderTmpId: 0, //暫時訂單編號
      openUrl: '',
      routerGoEnable: 0,
      deliveryFee:0,
      orderRewardPointInfo: { //點餐的紅利點數相關資料
        rewardPointList: [],
        rewardPointTakeoutList: [],
        rewardPointDeliveryList: [],
        rewardPointTableList: [],
        useRewardPointIdList: [],
        isLimitDiscountShare: false,
      },
    }
  },
  saveAllCartPageSnapshot(state, input){
    state.cartPageSnapshot={     //購物車頁面快照
      orderSettingTypeId: input.orderSettingTypeId,
      isLoading: input.isLoading,
      orderSn: input.orderSn,
      radioTake: input.radioTake,         //取餐方式
      showBank: input.showBank,        //更改付款方式
      paymentType: input.paymentType,
      showModel: input.showModel,       //取消揪團時，被分享者要出現的提示
      completeModel: input.completeModel,   //點餐成功彈框
      fareModel: input.fareModel,       //外送費說明彈框
      payModel: input.payModel,        //付款說明彈框
      showDelDialog: input.showDelDialog,   //刪除餐點彈框

      scrollHeight: input.scrollHeight,
      scrollTop: input.scrollTop,
      storeId: input.storeId,//店家id
      shoppingCartMealChoiceList: input.shoppingCartMealChoiceList, //購物車中的餐點資訊
      shoppingCartMealData: input.shoppingCartMealData,       //所有餐點資料
      refreshChoiceList: input.refreshChoiceList,
      delMealIndex: input.delMealIndex,     //暫存正在被刪除的餐點
      delMealOldVal:input.delMealOldVal,     //刪除前的數量
      delMealArr: input.delMealArr,         //紀錄被刪除的餐點
      originTotalPrice: input.originTotalPrice,    //小計
      oldOriginTotalPrice: input.oldOriginTotalPrice, //用優惠前小計
      sumAmount: input.sumAmount,           //總餐點數量
      couponList: input.couponList,         //優惠表
      discountLimit: input.discountLimit,        //優惠限制設定
      concatCouponList: input.concatCouponList,    //是否拼接優惠表
      couponChoiceList: input.couponChoiceList,       //已選擇的優惠券選項
      couponChoiceListItem: input.couponChoiceListItem,   //已選擇的優惠券
      calculatorCouponPrice: input.calculatorCouponPrice,    //計算經過coupon的金額
      orderGift: input.orderGift,      //可獲得票券
      taxIdNumber: input.taxIdNumber,    //統一編號
      mobileBarcode: input.mobileBarcode,    //手機條碼(載具)
      remark: input.remark,         //訂單備註

      storeInfo:input.storeInfo,
      userAddressData:input.userAddressData,
      userAddressId:input.userAddressId,
      userAddressParams: input.userAddressParams,
      deliveryConditionList:input.deliveryConditionList,//外送費資訊
      maxDistance:input.maxDistance,//最大運送距離
      isRequiredRemark:input.isRequiredRemark,//訂單備註欄位是否必填
      isRequestTableware:input.isRequestTableware,//是否顯示需要拋棄式餐具、吸管嗎？
      isRequiredTableware:input.isRequiredTableware,//是否需要拋棄式餐具、吸管
      remarkPrompt:input.remarkPrompt,//訂單備註欄位提示
      checkoutInstructions:input.checkoutInstructions,//結帳說明
      isCanCoupon:input.isCanCoupon,//顯示優惠券使用欄位(開啟時，可提供顧客使用優惠券)
      isCanTaxIdNumber:input.isCanTaxIdNumber,//顯示統一編號輸入欄位(開啟時，可提供顧客輸入統編)
      isCanMobileBarcode:input.isCanMobileBarcode,//顯示手機條碼(載具)輸入欄位(開啟時，可提供顧客輸入手機條碼)
      mealPreparationTimeType:input.mealPreparationTimeType,//餐點平均準備時間

      orderDeliveryList:input.orderDeliveryList,//取餐方式（自取、外送、小短腿）
      completeOrderData: input.completeOrderData,

      isCreditCard: input.isCreditCard,//高鉅信用卡彈框
      takeoutId:input.takeoutId,//我想修改訂單回來帶入參數
      paymentMethod:input.paymentMethod,
      orderTmpId: input.orderTmpId, //暫時訂單編號
      openUrl: input.openUrl,
      routerGoEnable: input.routerGoEnable,
      deliveryFee:input.deliveryFee,
      orderRewardPointInfo:input.orderRewardPointInfo,
    }
  },
  updateCartcouponChoiceListItem(state, input){
    state.cartPageSnapshot.couponChoiceListItem = input;
  },
  updateCartCouponChoiceList(state,input){
    state.cartPageSnapshot.couponChoiceList = input;
  },
  updateShoppingCartMealChoiceList(state,input){
    state.cartPageSnapshot.shoppingCartMealChoiceList = input;
  },
  updateShoppingCartMealData(state,input){
    state.cartPageSnapshot.shoppingCartMealData = input;
  },
  trigerCartDelDialog(state,input){
    state.cartPageSnapshot.showDelDialog = input.showDelDialog;
    state.cartPageSnapshot.delMealIndex = input.delMealIndex;
    state.cartPageSnapshot.delMealOldVal = input.delMealOldVal;
  },
  updateCartOnlineOrderAndOtherSetting(state,input){
    state.cartPageSnapshot.deliveryConditionList = input.deliveryConditionList;
    state.cartPageSnapshot.maxDistance = input.maxDistance;
    state.cartPageSnapshot.remarkPrompt = input.remarkPrompt;
    state.cartPageSnapshot.isRequiredRemark = input.isRequiredRemark;
    state.cartPageSnapshot.isRequestTableware = input.isRequestTableware;
    state.cartPageSnapshot.checkoutInstructions = input.checkoutInstructions;
    state.cartPageSnapshot.isCanCoupon = input.isCanCoupon;
    state.cartPageSnapshot.isCanTaxIdNumber = input.isCanTaxIdNumber;
    state.cartPageSnapshot.isCanMobileBarcode = input.isCanMobileBarcode;
    state.cartPageSnapshot.mealPreparationTimeType = input.mealPreparationTimeType;
    state.cartPageSnapshot.orderDeliveryList = input.orderDeliveryList;
    state.cartPageSnapshot.storeInfo = input.storeInfo;
    state.cartPageSnapshot.userAddressData = input.userAddressData;
    state.cartPageSnapshot.paymentMethod = input.paymentMethod;
  },
  updateShopAreaInfo(state,input){
    state.shopAreaInfo = input;
  },
  updateCartFinalPrice(state,input){
    state.cartPageSnapshot.finalPrice = input;
  },
  updateCartOriginTotalPrice(state,input){
    state.cartPageSnapshot.originTotalPrice = input;
  },
  updateCartOldOriginTotalPrice(state,input){
    state.cartPageSnapshot.oldOriginTotalPrice = input;
  },
  updateCartUserAddressData(state,input){
    state.cartPageSnapshot.userAddressData = input;
  },
  updateCartUserAddressId(state,input){
    state.cartPageSnapshot.userAddressId = input;
  },
  updateCartUserAddressParams(state,input){
    state.cartPageSnapshot.userAddressParams = input;
  },
  updateCartRadioTake(state,input){
    state.cartPageSnapshot.radioTake = input;
  },
  updateCartDeliveryFee(state,input){
    state.cartPageSnapshot.deliveryFee = input;
  },
  updateCartTaxIdNumber(state,input){
    state.cartPageSnapshot.taxIdNumber = input;
  },
  updateCartCalculatorCouponPrice(state,input){
    state.cartPageSnapshot.calculatorCouponPrice = input;
  },
  updateCartDiscountLimit(state,input){
    state.cartPageSnapshot.discountLimit = input;
  },
  updateCartCouponList(state,input){
    state.cartPageSnapshot.couponList = input;
  },
  updateCartShowBank(state,input){
    state.cartPageSnapshot.showBank = input;
  },
  updateCartPaymentType(state,input){
    state.cartPageSnapshot.paymentType = input;
  },
  updateCartOrderGift(state,input){
    state.cartPageSnapshot.orderGift = input;
  },
  updateCartMobileBarcode(state,input){
    state.cartPageSnapshot.mobileBarcode = input;
  },
  openCreditCardWindows(state,input){
    state.cartPageSnapshot.isCreditCard = input.isCreditCard;
    state.cartPageSnapshot.openUrl = input.openUrl;
  },
  /** 反掃結帳用 */
  setQRCodePay(state,input){
    state.qrCodePay.originTotalPrice = input.originTotalPrice;
    state.qrCodePay.storeId = input.storeId;
    state.qrCodePay.orderId = input.orderId;
  },
  updateQRCodePayPayment(state,input){
    state.qrCodePay.paymentType = input.paymentType;
  },
  updateQRCodePayStoreName(state,input){
    state.qrCodePay.storeName = input.storeName;
  },
  updateQRCodePayTotalPrice(state,input){
    state.qrCodePay.couponPrice = input.couponPrice;
    state.qrCodePay.calculatorCouponPrice = input.calculatorCouponPrice;
    state.qrCodePay.isDiscount = input.isDiscount;
    state.qrCodePay.couponChoiceListItem = input.couponChoiceListItem;
  },
  /** 設定是否清除購物車內容 */
  setClearCartData (state, data) {
    state.clearCartData = {...data};
  },
  updateCartDiscountedPrice(state, input) {
    state.cartPageSnapshot.discountedPrice = input;
  },

  /** 儲存新搜尋頁快照 */
  saveComplexPageSnapshot (state, payload) {
    if (payload === 'delete') {
      state.complexPageSnapshot = null;

    } else {
      state.complexPageSnapshot = payload;
    }
  },

  /** 儲存通知頁快照 */
  saveNotifyPageSnapshot (state, payload) {
    if (payload === 'delete') {
      state.notifyPageSnapshot = null;

    } else {
      state.notifyPageSnapshot = payload;
    }
  },

  updateStoreWebAction(state, data) {
    state.storeWebAction = {...state.storeWebAction, ...data};
  },

  /** 設定公用CommDialog */
  [types.setPublicCommDialogData] (state, data) {
    state.publicCommDialogData = {...state.publicCommDialogData, ...data};//保留舊值用新值改過去
  },

  /** 設定點餐店家相關資料 */
  [types.setOrderStoreInfo] (state, data) {
    state.orderStoreInfo = {...state.orderStoreInfo, ...data};//保留舊值用新值改過去
  },

  [types.setOpenPickTime] (state, data) {
    state.openPickTime = data
  },
  [types.setPickTimeData] (state, data) {
    state.pickTimeData.dateList = data.dateList
    state.pickTimeData.periodList = data.periodList
  },
  /** 設定點餐紅利點數相關資料 */
  [types.setOrderRewardPointInfo] (state, data) {
    state.cartPageSnapshot.orderRewardPointInfo = {...state.cartPageSnapshot.orderRewardPointInfo, ...data};//保留舊值用新值改過去
  },
  /** 設定點餐設定相關資料 */
  [types.setOrderSettingTypeId] (state, data) {
    state.cartPageSnapshot.orderSettingTypeId = data
  },
  getOffersList (state, data) {
    state.offersData.objectType = data.objectType || 0
    state.offersData.objectId = data.objectId || 0
  },
  /** 是否顯示MainPage的closeBtn */
  setIsMainCloseBtn (state, data) {
    state.isMainCloseBtn = data;
  },
  /** 記錄觸發時的時間戳記 */
  setTriggerTime (state, data) {
    state.lastTriggerTime = data;
  },
  /** deeplink享樂遊錢包的暫存資料(加密字串) */
  setOinPayData(state, data){
    state.oinPayForDeeplink.dataToken = data;
  },
  /** deeplink享樂遊錢包的暫存付款設定(物件) */
  setOinPaymentRequest(state, data){
    state.oinPayForDeeplink.paymentRequest = data;
  },
  /** 設定 setLineWebModeOn, line@頁面用, 通知其他頁面目前是 line@模式 */
  [types.setLineWebModeOn] (state, payload) {

  },
  /** 儲存 FilterStoreId */
  [types.updateFilterStoreId] (state, payload) {
    state.lineAtWebPageData.filterStoreId = payload;
  },
  /** 儲存 StoreCode */
  [types.updateStoreCode] (state, payload) {
    state.lineAtWebPageData.storeCode = payload;
  },

}
